module.exports = __webpack_public_path__ + "files/77ab22cbbd9aec1d6ffdcd53c1a020b1.svg";